import React from 'react';
import { Mountain, Facebook, Mail, MapPin, Heart } from 'lucide-react';
import { contactInfo } from '../data/mock';

export const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="bg-emerald-600 p-2 rounded-lg">
                <Mountain className="w-6 h-6 text-white" />
              </div>
              <div>
                <div className="font-bold text-lg text-white">Top of the Rock</div>
                <div className="text-sm text-emerald-400">Glamping</div>
              </div>
            </div>
            <p className="text-gray-400 mb-4 leading-relaxed">
              Luxury shepherd's huts and private camping in the heart of the Welsh mountains at Pen Y Graig Farm. 
              Perfect for romantic getaways and adventure seekers.
            </p>
            <div className="flex items-center space-x-4">
              <a
                href={contactInfo.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 p-2 rounded-lg hover:bg-emerald-600 transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="hover:text-emerald-400 transition-colors"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('accommodation')}
                  className="hover:text-emerald-400 transition-colors"
                >
                  Accommodation
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('activities')}
                  className="hover:text-emerald-400 transition-colors"
                >
                  Activities
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('gallery')}
                  className="hover:text-emerald-400 transition-colors"
                >
                  Gallery
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="hover:text-emerald-400 transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <MapPin className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-0.5" />
                <div>
                  <div className="text-sm">{contactInfo.farmName}</div>
                  <div className="text-sm text-gray-400">{contactInfo.location.address}</div>
                </div>
              </li>
              <li className="flex items-center space-x-2">
                <Facebook className="w-5 h-5 text-emerald-400 flex-shrink-0" />
                <a
                  href={contactInfo.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm hover:text-emerald-400 transition-colors"
                >
                  Follow us on Facebook
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {currentYear} Top of the Rock Glamping. All rights reserved.
            </p>
            <p className="text-sm text-gray-400 flex items-center space-x-1">
              <span>Made with</span>
              <Heart className="w-4 h-4 text-red-500 fill-current" />
              <span>in Wales</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
